<template>
  <BasePage :pageTitle="__DICT__.actionMenu.keyDist" back-button show-menu show-footer>
    <Card :title="cardTitle" show-status-bar margin="mb-4">
      <template #actions>
        <div class="dropdown">
          <button class="btn btn-outline-primary btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            {{ __DICT__.view }}
          </button>
          <div class="dropdown-menu dropdown-menu-end">
            <a class="dropdown-item" href="#" @click.prevent="changeView('loc')">{{ __DICT__.location }}</a>
            <a class="dropdown-item" href="#" @click.prevent="changeView('sup')">{{ __DICT__.supplier }}</a>
            <a class="dropdown-item" href="#" @click.prevent="changeView('bld')">{{ __DICT__.building }}</a>
          </div>
        </div>
      </template>
      <div v-if="listType === 'loc'" class="list-group list-group-flush">
        <template v-for="loc in distLocations" :key="loc.distLoc">
          <router-link
              :to="`/keyDist/loc/${btoa(loc.distLoc)}`"
              class="list-group-item list-group-item-action">
            {{ loc.distLoc }} <br/>
          </router-link>
        </template>
      </div>
      <div v-if="listType === 'sup'" class="list-group list-group-flush">
        <template v-for="sup in distSuppliers" :key="sup.supplier">
          <router-link
              :to="`/keyDist/sup/${btoa(sup.supplier)}`"
              class="list-group-item list-group-item-action">
            {{ sup.supplier }} <br/>
          </router-link>
        </template>
      </div>
      <div v-if="listType === 'bld'" class="list-group list-group-flush">
        <template v-for="bld in buildings" :key="bld.building">
          <router-link
              :to="`/keyDist/bld/${btoa(bld.buildingName)}`"
              class="list-group-item list-group-item-action">
            {{ bld.buildingName }} <br/>
          </router-link>
        </template>
      </div>
    </Card>
  </BasePage>
</template>

<script setup>
import BasePage from "@/components/BasePage.vue";
import {api} from "@/services/api.js";
import { encodeBase64Url } from "@/services/base64.js";
import {useWeekStore} from '@/stores/week.js'
import {ref, computed, onMounted} from "vue";
import {IconCaretLeftRightFilled} from '@tabler/icons-vue'
import { Card } from "@/components/atomic"

const weekStore = useWeekStore()

const distLocations = ref([]);
const distSuppliers = ref([]);
const buildings = ref([]);
const listType = ref("loc")
const cardTitle = ref("Distribution Location")

const changeView = (type) => {
  listType.value = type;

  if (type === "loc") {
    cardTitle.value = "Distribution Location";
  } else if (type === "sup") {
    cardTitle.value = "Supplier";
  } else if (type === "bld") {
    cardTitle.value = "Building";
  }
}

// Alias for template usage
const btoa = encodeBase64Url;

const fetchDistLocations = async () => {
  try {
    distLocations.value = (await api.get(`/api/keyDist/distLocations/${weekStore.systemId}`));
  } catch (error) {
    console.error('Failed to fetch distribution locations:', error);
  }
};

const fetchDistSuppliers = async () => {
  try {
    distSuppliers.value = (await api.get(`/api/keyDist/distSuppliers/${weekStore.systemId}`));
  } catch (error) {
    console.error('Failed to fetch suppliers:', error);
  }
};

const fetchBuildings = async () => {
  try {
    buildings.value = (await api.get(`/api/keyDist/distBuildings/${weekStore.systemId}`));
  } catch (error) {
    console.error('Failed to fetch buildings:', error);
  }
};

onMounted(() => {
  fetchDistLocations();
  fetchDistSuppliers();
  fetchBuildings();
});
</script>
